import React, { useEffect, lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CertificateWizard from './components/CertificateWizard';
import TermeniConditii from './pages/TermeniConditii';
import PoliticaConfidentialitate from './pages/PoliticaConfidentialitate';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import LocationPage from './pages/LocationPage';
import LocationsHub from './pages/LocationsHub';
import GuidesHub from './pages/GuidesHub';
import GuidePage from './pages/GuidePage';
import NotFound from './pages/NotFound';
import ReviewThankYou from './pages/ReviewThankYou';
import RedirectPreturi from './pages/RedirectPreturi';
import RedirectDespre from './pages/RedirectDespre';
import CookieBanner from './components/CookieBanner';
import GiftPopup from './components/GiftPopup';
import GoogleTracking from './components/GoogleTracking';
import SEOMetaTags from './components/SEOMetaTags';
import SchemaMarkup from './components/SchemaMarkup';
import TawkWidget from './components/TawkWidget';
import { API_URL } from './config';
import { captureAttribution } from './utils/attribution';

// Lazy load admin (recharts + dashboard nu trebuie în bundle-ul public)
const AdminLogin = lazy(() => import('./components/AdminLogin'));
const AdminDashboard = lazy(() => import('./components/AdminDashboard'));

function App() {
  // Atribuire sursă (first touch în sesiune) - înainte ca SPA să schimbe URL-ul
  useEffect(() => { captureAttribution(); }, []);

  // Dynamic Favicon Update
  useEffect(() => {
    const updateFavicon = async () => {
      try {
        const response = await fetch(`${API_URL}/api/orders/company`);
        const data = await response.json();

        if (data.favicon) {
          // Update favicon link tag
          let link = document.querySelector("link[rel*='icon']");

          if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.head.appendChild(link);
          }

          link.href = `${API_URL}${data.favicon}`;
          console.log('✅ Favicon updated:', link.href);
        }
      } catch (error) {
        console.error('Error updating favicon:', error);
        // Fallback - păstrează favicon-ul default din public/
      }
    };

    updateFavicon();
  }, []);
  return (
    <BrowserRouter>
      {/* SEO Meta Tags - injectare DOAR pe pagini publice (nu /admin/*) */}
      <SEOMetaTags />

      {/* Schema Markup (JSON-LD) - FAQPage, LocalBusiness, Service */}
      <SchemaMarkup />

      {/* Cookie Consent Banner (GDPR) - afișat pe toate paginile publice */}
      <CookieBanner />

      {/* Popup cadou la ieșire (03.11.2026) - doar desktop, după decizia la cookie-uri, pornit din Admin → Setări */}
      <GiftPopup />

      {/* Google Analytics + GTM - injectare doar cu consimțământ "Statistici" */}
      <GoogleTracking />

      {/* Tawk.to Live Chat - injectare dacă enabled în Admin Settings */}
      <TawkWidget />

      <Routes>
        <Route path="/" element={<CertificateWizard />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/admin/login" element={<Suspense fallback={<div></div>}><AdminLogin /></Suspense>} />
        <Route path="/admin/dashboard" element={<Suspense fallback={<div></div>}><AdminDashboard /></Suspense>} />
        <Route path="/termeni-conditii" element={<TermeniConditii />} />
        <Route path="/politica-confidentialitate" element={<PoliticaConfidentialitate />} />

        {/* Redirect routes - pentru link-uri directe /preturi și /despre-noi */}
        <Route path="/preturi" element={<RedirectPreturi />} />
        <Route path="/despre-noi" element={<RedirectDespre />} />

        {/* SEO Location Pages - extras carte funciară per oraș */}
        <Route path="/extras-carte-funciara" element={<LocationsHub />} />
        <Route path="/ghid" element={<GuidesHub />} />
        <Route path="/ghid/:slug" element={<GuidePage />} />
        <Route path="/extras-carte-funciara/:slug" element={<LocationPage />} />

        {/* Review pages - pentru email rating */}
        <Route path="/review/multumim" element={<ReviewThankYou />} />
        <Route path="/review/error" element={<ReviewThankYou />} />

        {/* 404 - Catch all unmatched routes */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
